<script setup>
import {onMounted, ref} from "vue";
import {ElNotification} from "element-plus";
import http from "@/http";
import {useStore} from "vuex"; // Import the useStore function
const store = useStore();

const props = defineProps(["close", "board_id", 'type']);

const loading = ref(false);
const baseUrl = ref(`${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/`);
const uploadUrl = ref(
    `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`
);
const uploadHeader = ref({Authorization: `${store.state.accessToken}`});
const showEditingModal = ref(false);
const selectedCouncilId = ref(null);
const file_id = ref(null);
const limit = ref(20);
const currentPage = ref(1);
const district_id = ref(null);
const can_moderator_upload = ref(false);
const councils = ref([]);
const councilsCount = ref(0);
const regionsLoading = ref(false);
const districtsLoading = ref(false);
const regions = ref([]);
const districts = ref([]);
const selectedRegion = ref(null);
const selectedDistrict = ref(null);
const fileName = ref('');


const handleCurrentChange = () => {
  getAllCouncil();
};

const handleSizeChange = () => {
  currentPage.value = 1;
  getAllCouncil();
};

const changeCouncilDecision = async () => {
  try {
    loading.value = true;
    if (props.type === 'council-decision') {
      await http.put(`api/v1/init-council-decisions/${selectedCouncilId.value}`,
          {
            file_id: file_id.value,
            title: fileName.value
          }
      );
    } else {
      await http.put(`api/v1/districts/documents/${props.type}/${selectedCouncilId.value}`,
          {
            file_id: file_id.value,
            file_name: fileName.value
          }
      );
    }


    ElNotification.success({
      message: "Muvoffaqiyatli yuklandi",
    });
    closeEditingModal();
    getAllCouncil();
  } catch (error) {
    ElNotification.error({
      message:
          JSON.parse(error?.message)?.message ||
          "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
      type: "error",
    });
  } finally {
    loading.value = false;
  }
};

const onSuccessUpload = (res) => {
  file_id.value = res.hashId;
  // if (store.state.role === "moderator") {
  //   createCouncilDecision();
  // } else
  if (store.state.role === "admin") {
    changeCouncilDecision();
  }
};

const onErrorUpload = (error) => {
  props.close();
  ElNotification.error({
    message:
        JSON.parse(error?.message)?.message ||
        "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
    type: "error",
  });

  loading.value = false;
};
const onExceed = (files) => {
  console.log("exceeds", files);
  // this.form.file[0] = files[0]
};

// const getSingleCouncil = async () => {
//   try {
//     loading.value = true;
//     let res = await http.get(`api/v1/districts/documents/${props.type}`, {
//       params: {
//         board_id: props.board_id,
//         district_id: district_id.value,
//       },
//     });
//     fileName.value = res.data.file_name
//     can_moderator_upload.value = false;
//   } catch (error) {
//     can_moderator_upload.value = true;
//   } finally {
//     loading.value = false;
//   }
// };

const getAllCouncil = async () => {
  try {
    loading.value = true;
    const {data} = await http.get(`api/v1/init-council-decisions`, {
      params: {
        board_id: props.board_id,
        region_id: selectedRegion.value,
        district_id: selectedDistrict.value,

        limit: limit.value,
        offset: limit.value * (currentPage.value - 1),
      },
    });
    councils.value = data.data;
    councilsCount.value = data.count;
  } catch (error) {
    ElNotification.error({
      message:
          "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
      type: "error",
    });
  } finally {
    loading.value = false;
  }
};

onMounted(() => {
  district_id.value = JSON.parse(
      localStorage.getItem("openBudget")
  ).user.district_id;
  // if (store.state.role === "moderator") {
  //   getSingleCouncil();
  // }

  if (store.state.role === "admin") {
    getRegions();
  }
  getAllCouncil();
});

const closeEditingModal = () => {
  showEditingModal.value = false;
  selectedCouncilId.value = null;
  file_id.value = null;
};

const downloadCouncil = (file_id = null) => {
  const link = document.createElement("a");
  link.href = baseUrl.value + file_id;
  link.setAttribute("download", "file");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const downloadAllAsExcel = () => {
  loading.value = true;
  http
      .get(`api/v1/districts/documents-excel`, {
        params: {
          board_id: props.board_id,
        },
        responseType: "blob",
      })
      .then((res) => {
        const url = URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
            })
        );
        const header = res.headers.get("Content-Disposition");
        const parts = header.split(";");
        let fileName = parts[1].split("=")[1];
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch(() => {
        ElNotification({
          title: "Ogohlantirish",
          message: "Ma'lumot yuklashda xatolik sodir bo'ldi!",
          type: "warning",
        });
      })
      .finally(() => {
        loading.value = false;
      });
};

const getRegions = () => {
  regionsLoading.value = true;
  http
      .get("/api/v1/regions")
      .then(({data}) => {
        regions.value = data.regions;
        selectedDistrict.value = null;
        getDistricts();
        getAllCouncil();
      })
      .catch(() => {
      })
      .finally(() => {
        regionsLoading.value = false;
      });
};
const getDistricts = () => {
  districtsLoading.value = true;
  http
      .get("/api/v1/districts", {
        params: {
          region_id: selectedRegion.value,
        },
      })
      .then(({data}) => {
        districts.value = data.districts;
        // selectedDistrict.value = districts.value[0].id;
        getAllCouncil();
      })
      .catch(() => {
      })
      .finally(() => {
        districtsLoading.value = false;
      });
};

const onEditCouncil = async (protocol_id, file_name, fileId) => {
  selectedCouncilId.value = protocol_id;
  fileName.value = file_name;
  file_id.value = fileId;
  showEditingModal.value = true;
};
</script>

<template>
  <div>
    <div v-if="store.state.role === 'admin'|| store.state.role === 'moderator'">
      <div class="filters">
        <el-button
            v-if="store.state.role === 'admin'"
            class="upload-demo"
            type="success"
            style="margin-right: 10px"
            @click="downloadAllAsExcel"
        >
          <img
              style="margin-right: 10px"
              alt=""
              src="@/assets/images/icons/download.svg"
          />
          Yuklab olish
        </el-button>
        <el-select
            v-if="store.state.role === 'admin'"
            placeholder="Viloyatlar"
            v-model="selectedRegion"
            @change="getRegions"
            :loading="regionsLoading"
        >
          <el-option value="" label="Barchasi"/>
          <el-option
              v-for="region in regions"
              :key="region.id"
              :value="region.id"
              :label="region.title"
          />
        </el-select>
        <el-select
            v-if="store.state.role === 'admin'"
            placeholder="Tuman/Shaxar"
            v-model="selectedDistrict"
            @change="getDistricts"
            :loading="districtsLoading"
        >
          <el-option value="" label="Barchasi"/>

          <el-option
              v-for="district in districts"
              :key="district.id"
              :value="district.id"
              :label="district.title"
          />
        </el-select>
      </div>

      <el-table v-loading="loading" :data="councils" border height="calc(100vh - 260px)">
        <el-table-column prop="title" label="Fayl nomi" min-width="150"/>
        <el-table-column prop="region" label="Viloyat" min-width="150"/>
        <el-table-column prop="district" label="Tuman/Shahar" min-width="100"/>
        <!--        <el-table-column-->
        <!--            prop="file_id"-->
        <!--            label="Kengash qarori fayl mavjudligi"-->
        <!--            min-width="100"-->
        <!--        >-->
        <!--          <template #default="scope">-->
        <!--            <div-->
        <!--                v-if="scope.row.file_id"-->
        <!--                style="display: flex; align-items: center; gap: 10px"-->
        <!--            >-->
        <!--              <p class="protocol_exists"></p>-->
        <!--              <p>mavjud</p>-->
        <!--            </div>-->
        <!--            <div-->
        <!--                v-if="!scope.row.file_id"-->
        <!--                style="display: flex; align-items: center; gap: 10px"-->
        <!--            >-->
        <!--              <p class="protocol_exists protocol_not_exists"></p>-->
        <!--              <p>mavjud emas</p>-->
        <!--            </div>-->
        <!--          </template>-->
        <!--        </el-table-column>-->
        <el-table-column min-width="100" label="tahrirlash/o'chirish">
          <template #default="scope">
            <el-button
                :disabled="!scope.row.file_id"
                size="small"
                @click="onEditCouncil(scope.row.id,scope.row.title,scope.row.file_id)"
                type="primary"
            >Tahrirlash
            </el-button
            >
            <el-button
                :disabled="!scope.row.file_id"
                size="small"
                class="upload-demo"
                type="success"
                @click="downloadCouncil(scope.row.file_id)"
            >
              <img
                  style="margin-right: 10px"
                  alt=""
                  src="@/assets/images/icons/download.svg"
              />
              Yuklab olish
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <div>Jami soni: {{ councilsCount }}</div>
        <el-pagination
            background
            layout="sizes, prev, pager, next"
            :total="councilsCount"
            v-model:page-size="limit"
            v-model:current-page="currentPage"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <el-dialog
        v-model="showEditingModal"
        @close="closeEditingModal"
        title="Kengash qarori faylni tahrirlash"
        align-center
    >

      <el-form-item v-if="type==='council-decision'" label="Kengash qarorining raqami va sanasi">
        <el-input type="text" v-model="fileName" placeholder="Kiriting"/>
      </el-form-item>
      <el-form-item label="Kengash qarori faylini yuklang" prop="file">
        <el-upload
            ref="uploadRef"
            class="upload-demo"
            :action="uploadUrl"
            :headers="uploadHeader"
            :multiple="false"
            accept="application/pdf"
            :limit="1"
            :on-exceed="onExceed"
            :on-success="onSuccessUpload"
            :on-error="onErrorUpload"
        >
          <template #trigger>
            <el-button style="width: 100%"
                       :disabled="fileName.length===0 && type==='council-decision'"
                       type="primary">
              Kengash qarori faylni tanlang
            </el-button>
          </template>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="changeCouncilDecision">
          Saqlash
        </el-button>
      </el-form-item>
    </el-dialog>
  </div>
</template>

<style scoped>
.protocol_exists {
  width: 20px;
  text-align: center;
  height: 20px;
  background: rgb(16, 191, 48);
  border-radius: 50%;
}

.protocol_not_exists {
  background: rgb(255, 0, 0);
}

.pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}

.filters {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 20px;
}
</style>
